import React from "react";

const PENDING_INVITE_KEY = "desktop_google_invite_token";

export const takeDesktopGoogleInvite = () => {
  try {
    const token = sessionStorage.getItem(PENDING_INVITE_KEY) || "";
    sessionStorage.removeItem(PENDING_INVITE_KEY);
    return token;
  } catch {
    return "";
  }
};

export const startDesktopGoogle = (inviteToken = "") => {
  try {
    if (inviteToken) sessionStorage.setItem(PENDING_INVITE_KEY, inviteToken);
    else sessionStorage.removeItem(PENDING_INVITE_KEY);
  } catch { /* unavailable */ }
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
  // THIS BREAKS THE AUTH.
  const redirectUrl = window.location.origin + "/desktop/auth-callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

function GoogleGlyph() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.8 32.8 29.4 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.1 8 3l5.7-5.7C34 6.3 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16.1 19 13 24 13c3.1 0 5.9 1.1 8 3l5.7-5.7C34 6.3 29.3 4 24 4c-7.7 0-14.4 4.4-17.7 10.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.1c-2 1.4-4.5 2.3-7.2 2.3-5.4 0-9.8-3.2-11.3-7.9l-6.5 5C9.4 39.5 16.1 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2-2.1 3.7-3.9 4.9l6.2 5.1C40.9 35 44 30 44 24c0-1.2-.1-2.4-.4-3.5z" />
    </svg>
  );
}

export const DesktopGoogleButton = ({ onClick, disabled = false, testId }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="flex min-h-11 w-full items-center justify-center gap-2 rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 shadow-sm transition-[background-color,border-color,box-shadow] hover:border-slate-400 hover:bg-slate-50 hover:shadow disabled:opacity-60"
    data-testid={testId}
  >
    <GoogleGlyph /> Continue with Google
  </button>
);